/**
 * Punch Action Registrations
 *
 * Registers all known punch actions with the PunchActionRegistry.
 * Each domain's action component is lazy-loaded via async imports.
 *
 * To add a new action:
 * 1. Create a Vue component following the PunchActionComponentProps contract
 * 2. Add a registerPunchAction() call below
 * 3. Create a PunchActionProcessor on the backend
 * 4. Add the action key to relevant PartyTask.app_data.task_actions
 */

import { registerPunchAction } from './punchActionRegistry'

// ─── Form Assignment ─────────────────────────────────────────
// Renders a Forms-domain FormAssignment inline while clocked in. Looks up
// pending/in-progress assignments bound to the current schedule and submits
// them through FormSubmissionService via PunchFormActionProcessor on clock-out.
registerPunchAction({
    key: 'form_assignment',
    component: () => import('@ja/forms/Components/PunchFormAction.vue'),
    adminLabel: 'Form assignment',
    trigger: 'while_clocked_in',
    blocking: false,
    defaultTiming: 'before',
    package: 'forms',
})

